<template>
  <div
    class="auth-v2 position-relative overflow-hidden"
    style="height: 100vh;"
  >
    <img
      src="@/assets/images/theme2/login-background.svg"
      alt="Auth V2"
      class="auth-shape position-absolute w-100  d-xl-block object-fit-cover"
      style="left: 0; bottom: 0; right: 0; z-index: 1;"
    >
    <img
      src="@/assets/images/theme2/login-lights-background.svg"
      alt="Auth V2"
      class="auth-shape position-absolute w-100   h-100"
      style="top: 0; left: 0; bottom: 0; right: 0; z-index: 1; object-fit: cover;"
      :class="$store.state.appConfig.layout.skin === 'dark' ? 'd-none' : 'd-xl-block'"
    >
    <b-row
      class="auth-inner m-0 v-xl-100vh"
      style=""
    >
      <div
        class="auth-bg relative d-flex align-items-xl-center justify-content-center w-100 "
        style="z-index: 2;  "
      >
        <div
          style="max-width: 1200px;"
          class="mx-auto bg-light w-100 d-flex rounded-lg overflow-hidden"
        >
          <div
            style="min-width: 600px;min-height: 750px;"
            class="flex-column justify-content-center align-items-center bg-dark_blue d-none d-xl-flex"
          >
            <div class="text-center ">
              <Logo class="" />
              <h1 class="mt-2 text-primary font-weight-bolder">
                {{ getBrandName() }}
              </h1>
              <h2 class="text-white font-weight-bolder">
                {{ getBrandSlogan() }}
              </h2>
            </div>
            <img
              src="@/assets/images/theme2/login-side-image.svg"
              alt=""
              class=" mt-4"
            >
          </div>
          <div
            style=""
            class="w-100 px-2"
          >
            <slot />
          </div>

        </div>
      </div>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Logo from '@/views/theme2/components/logo.vue'

export default {
  components: {
    Logo,
  },

}
</script>

<style lang="scss">

</style>
